import {gql} from '@apollo/client'

export const ADD_EDIT_TAG = gql`
  mutation tagInsuranceCreateupdateMutation($input: tag_Insurance_createUpdate_mutationInput!) {
    tagInsuranceCreateupdateMutation(input: $input) {
      tagInsurance {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`

// Borrado en dos tiempos: sin `force` el backend no borra nada si el tag esta en
// uso, devuelve requiresConfirmation + el detalle para avisar a que
// organizaciones afecta. Con `force` desvincula y borra en una transaccion.
export const DELETE_TAG_INSURANCE = gql`
  mutation deleteTagInsurance($id: ID!, $force: Boolean) {
    deleteTagInsurance(id: $id, force: $force) {
      ok
      requiresConfirmation
      unlinkedLeads
      usage {
        leadCount
        inUse
        crossesOrganizations
        organizations {
          organizationId
          organizationName
          leadCount
        }
      }
    }
  }
`
